//
//
//
//
//
//
//
//

    export default {
        data() {
            return {
                dateModel: '',
            }
        },
    }



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-date.vue